import type { INotification } from '@/contentTypes';
import { defineStore } from 'pinia';

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        notifications: [] as INotification[],
        notificationsToken: '',
        subscribedCategories: [] as number[],
    }),
    getters: {
        getNotifications(state) {
            return state.notifications.sort((a, b) => {
                const aDate = a.sentAt || a.sent_at || a.date || a.notification?.date || '';
                const bDate = b.sentAt || b.sent_at || b.date || b.notification?.date || '';
                return new Date(bDate).getTime() - new Date(aDate).getTime();
            });
        },
        getNotificationsToken(state) {
            return state.notificationsToken;
        },
        getSubscribedCategories(state) {
            return state.subscribedCategories;
        },
    },
    actions: {
        setNotifications(notifications: INotification[]) {
            this.notifications = notifications;
        },

        addNotification(notification: INotification) {
            this.notifications.push(notification);
        },
        deleteNotification(notificationId: number) {
            const notificationIndex = this.notifications.findIndex((notification) => notification.id === notificationId);
            this.notifications.splice(notificationIndex, 1);
        },
        resetNotifications() {
            this.notifications = [];
        },
        setNotificationsToken(token: string) {
            this.notificationsToken = token;
        },
        setSubscribedCategories(categories: number[]) {
            this.subscribedCategories = categories;
        },
        resetSubscribedCategories() {
            this.subscribedCategories = [];
        }
    },
    persist: true,
});
